import Store from "../store";
import { setCellValue } from "../global/api";
import { rowLocation } from "../global/location";
import { checkIsAllowEdit } from "../global/validate";
import luckysheetConfigsetting from "./luckysheetConfigsetting";

// 远程搜索下拉框控件
const remoteSelect = {
    loading: false, // 当前 loading 状态
    cellOptions: null, // 直接存储当前操作的数据对象
    selectBoxClass: "luckysheet-remote-select-box",
    selectItemClass: "luckysheet-remote-select-item",
    loadingClass: "luckysheet-remote-select-loading",

    // 隐藏下拉框
    hideRemoteSelect: function () {
        this.cellOptions = null;
        // 移除下拉框元素
        $(`.${this.selectBoxClass}`).remove();
        // 移除事件
        this.unbindOutsideClickEvent();
    },

    // 显示下拉框
    showRemoteSelect: function (dataList = []) {
        // *如果禁止前台编辑，则中止下一步操作
        if (!checkIsAllowEdit()) {
            return;
        }

        if (this.cellOptions == null) return;

        // 不然解析当前函数必要的参数
        const { popperClass = "", onSelect = null, setValue = null, r, c } = this.cellOptions;

        // 只要调用到这个函数，则认为已经获取到远程的数据了，开始处理下拉显示
        if (this.loading) {
            this.loading = false;
        }

        // 判定当前是否已经存在下拉框，如果存在，则替换下拉选项即可，不然就创建新的容器
        let $selectBox = $(`.${this.selectBoxClass}`);

        if ($selectBox.length > 0) {
            // 如果已存在下拉框，清空内容
            $selectBox.empty();
        } else {
            // 创建新的下拉框容器
            $selectBox = $("<div>");
            $selectBox.addClass(`${this.selectBoxClass} ${popperClass}`);
            // 添加到页面中
            $("body").append($selectBox);

            // 添加点击外部区域关闭下拉框的事件监听器
            this.bindOutsideClickEvent();
        }

        // 添加下拉选项
        if (Array.isArray(dataList) && dataList.length > 0) {
            dataList.forEach((item) => {
                const $item = $(`<div class="${this.selectItemClass}">`)
                    .text(item)
                    .click(() => {
                        // 设置单元格值
                        const last = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1];
                        if (last != null) {
                            last.row = [this.r, this.r];
                            last.column = [this.c, this.c];
                        }

                        // 触发选择回调
                        if (onSelect && typeof onSelect === "function") {
                            onSelect(item);
                        }

                        // 判断外部是否传递 setValue 方法
                        if (setValue && typeof setValue === "function") {
                            // 设置单元格内容
                            const value = setValue(item);
                            $("#luckysheet-input-box .luckysheet-cell-input").text(value);
                            setCellValue(r, c, value);
                        }

                        this.hideRemoteSelect();

                        // 并退出输入状态
                        $("#luckysheet-input-box").hide();
                    })
                    .bind(this);

                $selectBox.append($item);
            });
        }
        // 添加空数据处理逻辑
        else {
            const $noDataItem = $(`<div class="${this.selectItemClass}">`).text("暂无数据").css({
                color: "#999",
                "font-style": "italic",
                padding: "8px 12px",
                "text-align": "center",
            });
            $selectBox.append($noDataItem);
        }

        const $input = $("#luckysheet-input-box");
        const left = parseInt($input.css("left")) || 0;
        const top = parseInt($input.css("top")) || 0;

        // 获取当前单元格的高度 行高
        const [_row_pre, rowHeight] = rowLocation(this.r);

        // 设置下拉框位置和宽度
        $selectBox.css({
            top: `${top + rowHeight + 4}px`, // 在单元格下方显示
            left: `${left}px`,
        });
    },

    // 显示 loading
    showLoading: function () {
        // *如果禁止前台编辑，则中止下一步操作
        if (!checkIsAllowEdit()) {
            return;
        }

        if (!this.loading || this.cellOptions === null) return;

        const { r, popperClass } = this.cellOptions;

        // 获取下拉框元素，如果不存在则创建
        let $selectBox = $(`.${this.selectBoxClass}`);
        if ($selectBox.length === 0) {
            $selectBox = $("<div>");
            $selectBox.addClass(`${this.selectBoxClass} ${popperClass || ""}`);
            $("body").append($selectBox);
            this.bindOutsideClickEvent();
        }

        // 清空下拉列表选项并显示 loading 状态
        $selectBox.empty();
        $selectBox.append($(`<div class="${this.loadingClass}">加载中</div>`));

        const $input = $("#luckysheet-input-box");
        const left = parseInt($input.css("left")) || 0;
        const top = parseInt($input.css("top")) || 0;
        const [_row_pre, rowHeight] = rowLocation(r);
        $selectBox.css({
            top: `${top + rowHeight + 4}px`,
            left: `${left}px`,
        });
    },

    // 判断当前单元格是否需要显示下拉框
    checkCellNeedRemoteSelect: function (r, c) {
        this.cellOptions = null;

        // *如果禁止前台编辑，则中止下一步操作
        if (!checkIsAllowEdit()) return;

        // 调用函数判定
        const cellOptions = this.checkCellSelectable(r, c);
        if (!cellOptions) return;

        this.cellOptions = cellOptions;

        // 监听输入事件
        this.handleInput();
    },

    // 监听用户输入回调
    handleInput() {
        let $this = this;

        // 解析必要参数
        if (!this.cellOptions) return;
        const { onInput } = this.cellOptions;

        // 在用户输入时，调用外部接口实现搜索
        $("#luckysheet-input-box .luckysheet-cell-input")
            .off("input")
            .on("input", function () {
                let value = $(this).text().trim(); // 获取用户输入的值

                if (!value) return $this.hideRemoteSelect();

                // 如果当前单元格未配置 onInput 函数，则中止下一步操作
                if (!onInput || typeof onInput !== "function") return $this.hideRemoteSelect();

                // 设置 loading 状态为 true
                $this.loading = true;
                $this.showLoading();

                // 调用外部接口
                onInput(value)
                    .then(function (dataList) {
                        $this.loading = false;
                        $this.showRemoteSelect(dataList);
                    })
                    .catch((error) => {
                        $this.loading = false;
                        $this.hideRemoteSelect();
                        console.log("请求接口错误", error);
                        tooltip.info('<i class="fa fa-exclamation-triangle"></i>', "接口请求失败");
                    });
            });
    },

    // 绑定外部点击事件监听器
    bindOutsideClickEvent: function () {
        const $this = this;
        // 移除之前的事件监听器避免重复绑定
        $(document)
            .off("mousedown.remoteSelect")
            .on("mousedown.remoteSelect", function (e) {
                const $selectBox = $(`.${$this.selectBoxClass}`);
                // 检查点击的元素是否在下拉框内部
                if ($selectBox.length > 0 && !$selectBox.is(e.target) && $selectBox.has(e.target).length === 0) {
                    $this.hideRemoteSelect();
                }
            });
    },

    // 移除外部点击事件监听器
    unbindOutsideClickEvent: function () {
        $(document).off("mousedown.remoteSelect");
    },

    // 判断传入的 r c 是否需要显示下拉框 - 这个函数是对内的，兼容 celldata 及 remoteSelectOptions 两种配置模式
    checkCellSelectable: function (r, c) {
        // 通过 r c 获取单元格信息
        let cell = Store.flowdata[r][c];

        // 如果 cell 配置 remoteSelect 并且 remoteSelect.enable 为 true 则返回
        if (cell && cell.remoteSelect && cell.remoteSelect.enable) {
            return {
                ...cell.remoteSelect,
                r,
                c,
            };
        }

        // 不然，需要通过当前 sheet index 定位 传入的 remoteSelectOptions
        const sheetIndex = Store.currentSheetIndex;
        // console.log("sheetIndex", sheetIndex);

        const options = luckysheetConfigsetting.remoteSelectOptions || [];
        if (!options || !options.length) return null;

        const cellOptions = options.find((item) => item.r === r && item.c === c && item.index === sheetIndex);
        if (cellOptions && cellOptions.enable) return cellOptions;

        return null;
    },
};

export default remoteSelect;
